function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Contact Icon Updated");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Job-Board-Card-Recruiter",
  transform: "translate(-24.000000, -283.000000)",
  fill: "#002645"
}, React.createElement("g", {
  id: "Contact-Icon-Updated",
  transform: "translate(24.000000, 280.000000)"
}, React.createElement("g", {
  id: "Group",
  strokeWidth: 1,
  transform: "translate(0.850000, 7.540541)"
}, React.createElement("ellipse", {
  id: "Oval",
  cx: 10.2,
  cy: 5.02702703,
  rx: 5.1,
  ry: 5.02702703
}), React.createElement("path", {
  d: "M-2.59771371e-13,22.6216216 C0.53080963,16.5026114 4.89493936,11.7297297 10.2,11.7297297 C15.5050606,11.7297297 19.8691904,16.5026114 20.4,22.6216216 L-2.59792188e-13,22.6216216 Z",
  id: "Combined-Shape"
})), React.createElement("path", {
  d: "M22.736594,15.0810811 C28.1526479,15.0810811 32.6080847,19.8539627 33.15,25.972973 L22.8803567,25.972973 C21.5744196,22.2789148 18.7454311,19.4969142 15.3,18.6790626 C17.1970997,16.4572567 19.8283584,15.0810811 22.736594,15.0810811 Z",
  id: "Path"
}), React.createElement("g", {
  id: "Group",
  strokeWidth: 1,
  transform: "translate(17.850000, 3.351351)"
}, React.createElement("ellipse", {
  id: "Oval",
  cx: 5.1,
  cy: 5.02702703,
  rx: 5.1,
  ry: 5.02702703
})))));

var SvgContact = function SvgContact(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "34px",
    height: "28px",
    viewBox: "0 0 34 28",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContact, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact.ccc42a0c.svg";
export { ForwardRef as ReactComponent };